module.exports = __webpack_public_path__ + "static/media/static-2-Ca.5dda583d.png";